module.exports = __webpack_public_path__ + "static/media/Maui1.eb6f1141.webp";